YP.NotifManager = function() {
    return {
        show: function(settings){
            div = $('.c-notification');
            if(settings && settings.class) {
                $('.c-notification .c-notification__item').removeClass()
                                                          .addClass("c-notification__item c-notification__item--" + settings.class);
            }
            setTimeout(function(){
                if(settings && settings.message) {
                    $('.c-notification__item-info', div).html(settings.message);
                }
                div.slideDown(200,function(){
                    YP.NotifManager().hide();
                });
            }, 500);
        },
        hide: function() {
            setTimeout(function(){
                $('.c-notification').slideUp(200);
            }, 5000);
        },
        hideNow: function() {
            $('.c-notification').slideUp(200);
        },
        hasToShow: function() {
            return $('.c-notification__item-info').html() !== '';
        }
    }
};

window.addEventListener("load", function(){
    if(YP.NotifManager().hasToShow()) {
       YP.NotifManager().show()
    }

    $('.c-notification .c-btn').on('click', function(e){
        YP.NotifManager().hideNow();
    })
});
